import React, {useState, useEffect} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { PageLoading } from '../../Components/Loading';
import { useExperiments } from '../../Data/Admin';
import Form, { Actions, Radio } from '../../Components/Form';
import Modal from '../../Components/Modal';
import Button from '../../Components/Button/Button';
import ButtonRow from '../../Components/Button/ButtonRow';
import Chart from '../../Components/Chart';
import Section, { Sections } from '../../Components/Containers/Section';

const modelOptions = ['Quote', 'User'];
const dayOptions = [7, 14, 30, 90, 180, 365];

const chartFormat = {
    responsive: false,
    maintainAspectRatio: true,
    plugins: {
        title: {
            display: false,
            text: 'Experiment Chart',
        },
    },
    scales: {
        x: {
            stacked: false,
            min: 0,
        },
        y: {
            stacked: false,
            min: 0,
        },
    },
};

const colors = [
    '#dc3545',
    '#28a745',
    '#314695',
    '#e83e8c',
    '#6f42c1',
];

const Experiments = () => {
    const [model, setModel] = useState('Quote');
    const [days, setDays] = useState(30);
    const {experiments, isLoading, refresh} = useExperiments(model, days);

    const [optionsOpen, setOptionsOpen] = useState(false);

    useEffect(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [model, days]);

    return <>
        <TopBar left="/admin" title="Experiments" />
        <Page>
            <div className="flex justify-between items-center mb-4">
                <ButtonRow>
                    {modelOptions.map(m => <Button key={m}
                        theme={m === model ? 'primary' : 'light'}
                        label={m}
                        onClick={() => setModel(m)}
                        zeroMargin
                    />)}
                    <div className="p-2 text-muted">
                        {days} Days
                    </div>
                </ButtonRow>
                <div>
                    <Button theme="light" icon="ChartSimple" onClick={() => setOptionsOpen(true)} zeroMargin />
                </div>
            </div>
            {(experiments && !isLoading) ? <Inner {...{experiments, model}} /> : <PageLoading />}
        </Page>

        <Options {...{optionsOpen, setOptionsOpen, model, days, setModel, setDays}} />
    </>
}

const Inner = ({experiments, model}) => {
    if (!experiments || experiments.length === 0) {
        return <p className="py-5 text-center text-muted">No data to show</p>
    }

    return <Sections>
        {experiments.map(exp => {
            return <Section key={exp.name} title={exp.title} subtitle={exp.name}>
                <Chart type="Bar" data={marshal(exp.results, exp.name)} options={chartFormat} />
            </Section>
        })}
    </Sections>
}

const Options = ({optionsOpen, setOptionsOpen, model, days, setModel, setDays}) => {
    const change = (data) => {
        setModel(data.model);
        setDays(data.days);
    }

    return <Modal isOpen={optionsOpen} setIsOpen={setOptionsOpen} title="Chart Options">
        <Form data={{model, days}} onSubmit={change} closeModalOnSubmit>
            <Radio name="model"
                label="Model"
                options={modelOptions.map(m => ({value: m, label: m}))}
            />
            <Radio name="days"
                label="Days"
                options={dayOptions.map(d => ({value: d, label: d}))}
            />
            <Actions submit={{label: 'Change'}} cancel />
        </Form>
    </Modal>
}

const marshal = (results, label) => {
    return {
        labels: [label],
        datasets: results.map((r, i) => ({
            label: r.name,
            data: [r.count],
            backgroundColor: colors[i],
        }))
    };
}

export default Experiments;
